import { ArrowRight, Image, ScanFace, Sparkles, Video } from "lucide-react";

const STAGES = [
  {
    title: "Customer source",
    detail:
      "The original uploaded image or video. “Source” does not mean open source.",
    icon: Image,
  },
  {
    title: "Media analysis",
    detail:
      "Gemini and deterministic analyzers record subjects, boxes, dimensions, and confidence.",
    icon: ScanFace,
  },
  {
    title: "Canonical framing plan",
    detail:
      "A frozen scene decision chooses crop/contain behavior and protected subjects. Postcard is not selectable.",
    icon: Sparkles,
  },
  {
    title: "I2V when needed",
    detail:
      "Still-image animation records requested and concrete provider/model separately. Veo 3.1 routes and any fallback remain explicit evidence.",
    icon: Video,
  },
  {
    title: "Delivered-pixel proof",
    detail:
      "The applied render receipt and encoded-delivery QC are compared with the frozen plan.",
    icon: ScanFace,
  },
] as const;

export function CropPipelinePanel() {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border bg-muted/30 p-4 text-sm">
        Crop Debug follows evidence, not intended configuration. If the
        requested I2V route differs from the concrete provider/model, both
        should appear so a fallback cannot masquerade as Veo.
      </div>
      <ol className="grid gap-3 xl:grid-cols-5">
        {STAGES.map((stage, index) => {
          const Icon = stage.icon;
          return (
            <li key={stage.title} className="relative rounded-lg border p-4">
              <div className="flex items-center gap-2">
                <Icon className="size-4 text-primary" />
                <strong className="text-sm">{stage.title}</strong>
              </div>
              <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
                {stage.detail}
              </p>
              {index < STAGES.length - 1 ? (
                <ArrowRight className="absolute -right-3 top-1/2 z-10 hidden size-5 -translate-y-1/2 rounded-full bg-background text-muted-foreground xl:block" />
              ) : null}
            </li>
          );
        })}
      </ol>
      <p className="text-xs text-muted-foreground">
        Pixel access stays administrator-only, uses short-lived media links, and
        is recorded in the evidence-access audit.
      </p>
    </div>
  );
}
